import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { PrimeNGToastSeverity } from '../enums/primeng-toast-severity';
import { ConstantsService } from './constants.service';

/**
 * Service to notify users that a feature is not yet available. Utilizes toast notifications to display the message.
 *
 * NOTE: Even if this service is not used, keep it in the project...
 * it should be used whenever developer wants to inform the user that the given feature will be implemented in the future
 */
@Injectable({
    providedIn: 'root',
})
export class FeatureNotAvailableService {
    constructor(
        private readonly toastService: MessageService,
        private readonly translateService: TranslateService
    ) {}

    /**
     * Displays a toast notification indicating that the feature is not available yet.
     */
    public notAvailableYetToast(): void {
        this.toastService.add({
            key: ConstantsService.TOAST_KEY,
            severity: PrimeNGToastSeverity.ERROR,
            summary: this.translateService.instant(
                'shared.toast.notAvailable.summary'
            ),
            detail: this.translateService.instant(
                'shared.toast.notAvailable.detail'
            ),
        });
    }

    /**
     * Returns a string indicating that the feature is not available yet.
     *
     * The string is localized using 'TranslateService.instant(key: string)' method
     */
    public notAvailableYetString(): string {
        return this.translateService.instant(
            'shared.toast.notAvailable.detail'
        );
    }
}
